import { useEffect } from 'react';

import type { FlowConfig } from 'src/viewLayer/components/Flow/types';

interface UsePushToDataLayerParams {
  nodeNumber?: number,
  flowConfig?: FlowConfig
};

const usePushToDataLayer = ({ nodeNumber, flowConfig }: UsePushToDataLayerParams): void => {
  window.dataLayer = window.dataLayer || [];
  const currentNode = flowConfig?.flow?.[nodeNumber];
  const pageName = currentNode?.gaPageViewName || currentNode?.type;

  useEffect(() => {
    if (currentNode) {
      window.dataLayer.push({
        event: 'pageview',
        virtPath: window.location.href,
        pageName,
        marketingContentGroup: 'ppf', // as defined in src/init/setMetaTags.js
        flowId: flowConfig.id
      });
    }
  });
};

export default usePushToDataLayer;
